import { styled } from "@material-ui/styles";

export const ButtonsContainer = styled("div")({
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    marginBottom: "10px",
});
